import { render, staticRenderFns } from "./AppWidget.vue?vue&type=template&id=6d23711c&scoped=true&"
import script from "./AppWidget.vue?vue&type=script&lang=js&"
export * from "./AppWidget.vue?vue&type=script&lang=js&"
import style0 from "./AppWidget.vue?vue&type=style&index=0&id=6d23711c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23711c",
  null
  
)

export default component.exports